'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.PLAT_KARTA = exports.POST_POUKAZKA = exports.BANK_PREVOD = exports.HOTOVE = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:22:50Z                      #

// ##############################################################

/**
 * Tzp formy úhrady faktury.
 */

/**
 * Hotově.
 */
var HOTOVE = exports.HOTOVE = 'HOTOVE';

/**
 * Bankovním převodem.
 */
var BANK_PREVOD = exports.BANK_PREVOD = 'BANK_PREVOD';

/**
 * Poštovní poukázka.
 */
var POST_POUKAZKA = exports.POST_POUKAZKA = 'POST_POUKAZKA';

/**
 * Platební karta.
 */
var PLAT_KARTA = exports.PLAT_KARTA = 'PLAT_KARTA';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [HOTOVE, BANK_PREVOD, POST_POUKAZKA, PLAT_KARTA];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, HOTOVE, { caption: 'Hotově.' }), (0, _defineProperty3.default)(_params, BANK_PREVOD, { caption: 'Bankovním převodem.' }), (0, _defineProperty3.default)(_params, POST_POUKAZKA, { caption: 'Poštovní poukázka.' }), (0, _defineProperty3.default)(_params, PLAT_KARTA, { caption: 'Platební karta.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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